import {Component, EventEmitter, Input, Output} from '@angular/core';

import {LinkComponent} from "../link/link.component";

@Component({
    selector: 'app-error',
    imports: [
        LinkComponent
    ],
    templateUrl: './error.component.html',
    styleUrl: './error.component.scss'
})
export class ErrorComponent {
  @Input() public message: string = '';
  @Input() public linkText: string = '';
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() public  click: EventEmitter<void> = new EventEmitter<void>();

  public selected(event: Event): void {
    event.stopPropagation();
    this.click.emit();
  }
}
